import type { Paged } from '@/domain/entities/paging'

/** BE bisa membungkus payload dalam { data } atau mengirimnya langsung. */
export function unwrap<T>(raw: unknown): T {
  if (raw && typeof raw === 'object' && 'data' in raw) return (raw as { data: T }).data
  return raw as T
}

export function unwrapList<T>(raw: unknown): T[] {
  if (Array.isArray(raw)) return raw as T[]
  const value = unwrap<unknown>(raw)
  return Array.isArray(value) ? (value as T[]) : []
}

interface MetaDto {
  total?: number | null
  total_pages?: number | null
}

function readMeta(raw: unknown): MetaDto | null {
  if (raw && typeof raw === 'object' && 'meta' in raw) {
    const meta = (raw as { meta: unknown }).meta
    if (meta && typeof meta === 'object') return meta as MetaDto
  }
  return null
}

/**
 * Bentuk metadata paging BE belum dipastikan, jadi helper ini defensif:
 * pakai meta bila ada, kalau tidak simpulkan hasNext dari panjang halaman.
 */
export function unwrapPaged<T>(raw: unknown, page: number, limit: number): Paged<T> {
  const items = unwrapList<T>(raw)
  const meta = readMeta(raw)
  const total = typeof meta?.total === 'number' ? meta.total : undefined
  const totalPages = typeof meta?.total_pages === 'number' ? meta.total_pages : undefined

  let hasNext: boolean
  if (totalPages !== undefined) hasNext = page < totalPages
  else if (total !== undefined) hasNext = page * limit < total
  else hasNext = items.length === limit

  return { items, page, limit, total, hasNext }
}
